// mutations
const SET_DATALOGIN = (state, payload) => {
  state.dataLogin = payload;
};
const SET_RESUSERINFO = (state, payload) => {
  state.res_userInfo = payload;
};
const SET_RESUSERINFOMETA = (state, payload) => {
  state.res_userInfoMeta = payload;
};
const SET_TEMPINPUT = (state, payload) => {
  state.temp_input = payload;
};
export default {
  SET_DATALOGIN,
  SET_RESUSERINFO,
  SET_TEMPINPUT,
  SET_RESUSERINFOMETA
};
